import React, { Component } from 'react';
import ClampLines from 'react-clamp-lines';
import moment from 'moment';

import './BlogCell.css';
import ExternalLink from './ExternalLink';
import { trackHostClick } from '../utils';

class BlogCell extends Component {
  render() {

    const {
      item,
      shadowItem,
    } = this.props;

    let tags = null;
    let link = null;
    let separator = null;
    let user = null;
    const date = moment(item.date).format('LL');
    let authorPhotoUrl = '../blog_authors/' + item.user.toLowerCase().replace(/\s/g, "_") + ".jpg";
    if (item.tags) {
      tags = (
        <div className="lp-tags">
          <div className="lp-shadow">
            {shadowItem.tags}
          </div>
          <div className="lp-overlay">
            {item.tags}
          </div>
        </div>
      );
    }
    if (item.link) {
      link = (
        <div className="lp-link">
          <ExternalLink data={item.link} />
        </div>
      );
    }
    if (item.user) {
      separator = (
        <div className="lp-separator" />
      );
      user = (
        <div className="lp-user">
          <div className="lp-avatar">
            <img src={authorPhotoUrl} alt="User Avatar"  onError={(e) => {
              e.target.onerror = null;
              e.target.src = '../avatar_default.svg';
            }} />
          </div>
          <div className="lp-user-details">
            <span>
              {item.user}
            </span>
            <span>
              {date}
            </span>
          </div>
        </div>
      );
    }

    return (
      <a className="lp-blog-cell-wrapper" href={item.url} target="_blank" rel="noopener noreferrer" onClick={e => {
        trackHostClick(e, 'a blog cell');
      }}>
        <div className="lp-blog-cell">
          {tags}
          <div className="lp-title">
            <div className="lp-shadow">
              {shadowItem.title}
            </div>
            <div className="lp-overlay">
              {item.title}
            </div>
          </div>
          <ClampLines
            className="lp-clamp"
            buttons={false}
            moreText="Expand"
            lessText="Collapse"
            lines={3}
            text={item.content} />
          {link}
          {separator}
          {user}
        </div>
      </a>
    );
  }
}

export default BlogCell;



// WEBPACK FOOTER //
// ./src/components/BlogCell.js